import React, { useState, useEffect } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { useAuth } from "../../context/GlobalContext";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { ArrowForward } from "@material-ui/icons";
import "../../style/Login.css";
import { images, textInputs } from "../../constants/constants";

function Login() {
  const [showPassword, setShowPassword] = useState(false);
  const [username, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(true);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { state, login } = useAuth();
  const history = useHistory();

  useEffect(() => {
    if (state.user) {
      history.push("/");
    }
  }, [state.user, history]);

  useEffect(() => {
    try {
      const saved = sessionStorage.getItem("loginRememberUser");
      if (saved) setEmail(saved);
    } catch {
      /* ignore */
    }
  }, []);

  const validateForm = () => username.length > 0 && password.length > 0;

  const handleLogin = (event) => {
    event.preventDefault();
    setError(null);
    if (!validateForm()) return;

    setIsLoading(true);

    axios
      .post("/api/user/login", {
        username,
        password,
      })
      .then(() => {
        if (rememberMe && username) {
          try {
            sessionStorage.setItem("loginRememberUser", username);
          } catch {
            /* ignore */
          }
        } else {
          try {
            sessionStorage.removeItem("loginRememberUser");
          } catch {
            /* ignore */
          }
        }
        login();
        history.push("/");
      })
      .catch(() => {
        setError("Invalid credentials. Please try again.");
        setIsLoading(false);
      });
  };

  return (
    <div className="mushin-login-wrapper">
      <div className="mushin-login-container">
        <div className="mushin-login-hero">
          <div className="mushin-hero-content mushin-fade-in-1">
            <div className="mushin-hero-branding">
              <img
                className="mushin-hero-logo"
                src="https://mushin-labs.s3.ap-south-1.amazonaws.com/logo/Logo+Red-White+-MUSHIN+TECH.png"
                alt="Mushin"
              />
            </div>
            <div className="mushin-hero-text mushin-fade-in-2">
              <h1 className="mushin-hero-title">
                THE <span className="mushin-highlight">OPERATING SYSTEM</span>
                <br />
                FOR FACTORY OPERATIONS
              </h1>
              <p className="mushin-hero-subtitle">
                One connected system for quality, production, traceability,
                audits, maintenance, and more. Built to digitize every critical
                function on the plant floor.
              </p>
            </div>
          </div>
          <div className="mushin-hero-gradient"></div>
        </div>

        <div className="mushin-login-panel">
          <div className="mushin-panel-content">
            <div className="mushin-panel-header mushin-fade-in-1">
              <div>
                <h2 className="mushin-panel-title">Welcome back</h2>
                <p className="mushin-panel-subtitle">
                  Sign in to your portal
                </p>
              </div>
              {images.CompanyLogo && (
                <div className="mushin-customer-logo-wrapper">
                  <img
                    src={images.CompanyLogo}
                    alt={textInputs.companyName || "Customer"}
                    className="mushin-customer-logo"
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                  />
                </div>
              )}
            </div>

            <form
              className="mushin-login-form mushin-fade-in-4"
              onSubmit={handleLogin}
            >
              <div className="mushin-form-group">
                <label className="mushin-form-label" htmlFor="login-email">
                  USER ID / EMAIL
                </label>
                <input
                  className="mushin-form-input"
                  id="login-email"
                  name="email"
                  type="text"
                  autoComplete="username"
                  placeholder="you@company.com"
                  value={username}
                  onChange={(e) => setEmail(e.target.value)}
                  autoFocus
                />
              </div>

              <div className="mushin-form-group">
                <label className="mushin-form-label" htmlFor="login-password">
                  PASSWORD
                </label>
                <div className="mushin-password-wrapper">
                  <input
                    className="mushin-form-input mushin-password-input"
                    id="login-password"
                    name="password"
                    type={showPassword ? "text" : "password"}
                    autoComplete="current-password"
                    placeholder="Enter your password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <button
                    className="mushin-password-toggle"
                    type="button"
                    tabIndex={-1}
                    onClick={() => setShowPassword((v) => !v)}
                    aria-label={showPassword ? "Hide password" : "Show password"}
                  >
                    {showPassword ? (
                      <VisibilityOff fontSize="small" />
                    ) : (
                      <Visibility fontSize="small" />
                    )}
                  </button>
                </div>
              </div>

              <div className="mushin-form-options">
                <label className="mushin-checkbox-label">
                  <input
                    type="checkbox"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                    className="mushin-checkbox"
                  />
                  <span className="mushin-checkbox-text">Remember me</span>
                </label>
              </div>

              {error && (
                <div className="mushin-error-alert" role="alert">
                  {error}
                </div>
              )}

              <button
                className="mushin-submit-btn"
                type="submit"
                disabled={!validateForm() || isLoading}
              >
                {isLoading ? (
                  <>
                    <span className="mushin-spinner"></span>
                    Signing in...
                  </>
                ) : (
                  <>
                    Sign in
                    <ArrowForward fontSize="small" />
                  </>
                )}
              </button>
            </form>

            <div className="mushin-panel-footer mushin-fade-in-5">
              <p className="mushin-footer-text">
                Powered by{" "}
                <strong className="mushin-footer-brand">Mushin AQUA</strong>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
